import { getExternalAuthContext } from './external-view-state';

const EXTERNAL_PATH = '/external';

export function shouldBootstrapExternalAuth(pathname: string, _search: string): boolean {
  if (pathname.startsWith(EXTERNAL_PATH)) {
    return true;
  }

  const query = new URLSearchParams(_search);
  const hasAuthorizationResponse = query.has('code') || query.has('error');
  const hasStoredExternalContext = Boolean(getExternalAuthContext());

  return hasAuthorizationResponse && hasStoredExternalContext;
}
